import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Ticket from '@deliveroo/icon-set/react/Ticket';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import ParticleEffect from '@deliveroo/consumer-component-library/components/ParticleEffect';

import CreditRedemptionActions from '../CreditRedemptionActions';

import styles from './CreditStatusModal.scss';

export default class CreditStatusModal extends React.Component {
  componentDidMount() {
    Modal.setAppElement(this.props.appElement);
  }

  render() {
    const { isDisplayed, dismissModalHandler, success, title, body, actions } = this.props;

    return (
      <Modal
        isOpen={isDisplayed}
        onRequestClose={dismissModalHandler}
        className={{
          base: styles.modal,
          afterOpen: styles.modalAfterOpen,
          beforeClose: styles.modalBeforeClose,
        }}
        overlayClassName={{
          base: styles.modalOverlay,
          afterOpen: styles.modalOverlayAfterOpen,
          beforeClose: styles.modalOverlayBeforeClose,
        }}
      >
        {success && (
          <ParticleEffect
            type="confetti"
            isLooping={false}
            particleDensity={20}
            gravity={2}
            fadeThreshold={0.5}
          />
        )}
        <div className={styles.statusContent}>
          {success && (
            <div className={styles.icon}>
              <Icon component={Ticket} />
            </div>
          )}
          <Heading level={3} size="x-small">
            {title}
          </Heading>
          <P color="grey">{body}</P>
          <CreditRedemptionActions actions={actions} />
        </div>
      </Modal>
    );
  }
}

CreditStatusModal.propTypes = {
  isDisplayed: PropTypes.bool.isRequired,
  dismissModalHandler: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
      href: PropTypes.string,
      onClick: PropTypes.func,
      title: PropTypes.string.isRequired,
      icon: PropTypes.elementType, // eslint-disable-line react/no-typos
      isDisabled: PropTypes.bool,
    }),
  ).isRequired,
  appElement: PropTypes.string.isRequired,
};

CreditStatusModal.defaultProps = {
  body: undefined,
};
